import * as Types from '../../../../generated/types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type SubscriptionPlansQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type SubscriptionPlansQuery = { __typename: 'Query', subscriptionPlans: string };

export type CreateCheckoutSessionMutationVariables = Types.Exact<{
  priceLookupKey: Types.Scalars['String']['input'];
  successUrl: Types.Scalars['String']['input'];
  cancelUrl: Types.Scalars['String']['input'];
}>;


export type CreateCheckoutSessionMutation = { __typename: 'Mutation', createCheckoutSession: string };

export const SubscriptionPlansDocument = gql`
    query SubscriptionPlans {
  subscriptionPlans
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SubscriptionPlansGQL extends Apollo.Query<SubscriptionPlansQuery, SubscriptionPlansQueryVariables> {
    override document = SubscriptionPlansDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCheckoutSessionDocument = gql`
    mutation CreateCheckoutSession($priceLookupKey: String!, $successUrl: String!, $cancelUrl: String!) {
  createCheckoutSession(
    input: {priceLookupKey: $priceLookupKey, successUrl: $successUrl, cancelUrl: $cancelUrl}
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCheckoutSessionGQL extends Apollo.Mutation<CreateCheckoutSessionMutation, CreateCheckoutSessionMutationVariables> {
    override document = CreateCheckoutSessionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }